import { render, staticRenderFns } from "./valid-customer.vue?vue&type=template&id=431e5cdc&scoped=true&"
import script from "./valid-customer.vue?vue&type=script&lang=js&"
export * from "./valid-customer.vue?vue&type=script&lang=js&"
import style0 from "./valid-customer.vue?vue&type=style&index=0&id=431e5cdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431e5cdc",
  null
  
)

export default component.exports